import React from 'react';
import styled from 'styled-components';
import { Text, Color } from '@brokerbay/elements-web';

const Section: React.FC<{
  title?: string;
  headingIcon?: JSX.Element;
}> = ({ headingIcon, title, children }) => (
  <SectionContainer $title={title}>
    {title && (
      <Header>
        <HeaderText thickness="bold" size="large">
          {title}
        </HeaderText>
        <p>{headingIcon}</p>
      </Header>
    )}
    {children}
  </SectionContainer>
);
export default Section;

const SectionContainer = styled.div<{ $title: string | undefined }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  ${({ $title }) => $title && `border-top: 1px solid ${Color.BORDER_GREY};`}
  padding: 15px 0px;
`;
const HeaderText = styled(Text)`
  color: ${Color.BLACK};
  margin-bottom: 16px;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
